/*
  In vanilla JS instances and inputs, the decimal prop can be passed an arg that
  is not an integer number, or a number that's out of range of what
  Intl.NumberFormat allows for. To prevent runtime errors, we just default to 0
  if we see non valid decimal args.
*/

export var getSantizedDecimals = decimals => typeof decimals === 'number' && decimals >= 0 && decimals <= 16 ? Math.round(decimals) : 0;
export default getSantizedDecimals;